import { Link } from 'react-router-dom';
import { Navbar } from '@/components/layout/Navbar';

export function LandingPage() {

  return (
    <div className="bg-background-light dark:bg-background-dark text-slate-900 dark:text-slate-100 font-sans transition-colors duration-300 min-h-screen">
      <style>{`
        .text-gradient {
            background-clip: text;
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
        }
        .blob {
            position: absolute;
            filter: blur(80px);
            z-index: 0;
            opacity: 0.4;
        }
      `}</style>

      <Navbar variant="landing" />

      <section className="relative pt-20 pb-32 overflow-hidden">
        <div className="blob bg-blue-500 w-96 h-96 rounded-full top-0 -left-20 animate-pulse pointer-events-none"></div>
        <div className="blob bg-purple-500 w-96 h-96 rounded-full bottom-0 -right-20 animate-pulse delay-700 pointer-events-none"></div>
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col items-center text-center">
          <div className="inline-flex items-center px-4 py-2 rounded-full bg-indigo-50 dark:bg-indigo-900/30 border border-indigo-100 dark:border-indigo-800 mb-8">
            <span className="flex h-2 w-2 rounded-full bg-primary mr-2"></span>
            <span className="text-xs font-semibold text-primary uppercase tracking-wide">New: GPT-4 Integration</span>
          </div>
          <div className="flex flex-col md:flex-row items-center justify-center gap-6 mb-6">
            <img
              src="/logo_notext.png"
              alt="Uniscout Logo"
              className="h-72 w-auto scale-x-[-1]"
            />
            <h1 className="text-5xl md:text-7xl font-display font-bold tracking-tight text-slate-900 dark:text-white text-center md:text-left">
              Your AI Analyst for <br />
              <span className="bg-logo-text text-gradient">Startup Evaluation</span>
            </h1>
          </div>
          <p className="mt-4 text-xl text-slate-600 dark:text-slate-300 max-w-2xl mx-auto mb-10 leading-relaxed">
            uniscout.ai automates due diligence. Upload a pitch deck or URL, and get comprehensive investment memos, market analysis, and risk assessments in seconds.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 w-full justify-center">
            <Link to="/register">
              <button className="bg-logo-gradient hover:opacity-90 text-white px-8 py-4 rounded-xl text-lg font-semibold transition-all shadow-xl shadow-primary/25 flex items-center justify-center gap-2">
                <span className="material-icons">rocket_launch</span>
                Analyze a Startup Free
              </button>
            </Link>
            <Link to="/how-it-works">
              <button className="bg-white dark:bg-surface-dark border border-slate-200 dark:border-slate-700 text-slate-700 dark:text-slate-200 hover:bg-slate-50 dark:hover:bg-slate-800 px-8 py-4 rounded-xl text-lg font-semibold transition-all flex items-center justify-center gap-2">
                <span className="material-icons">play_circle</span>
                How it works
              </button>
            </Link>
          </div>
          <div className="mt-20 relative w-full max-w-5xl">
            <div className="absolute -inset-1 bg-logo-gradient rounded-2xl blur opacity-30 dark:opacity-40"></div>
            <div className="relative bg-surface-light dark:bg-surface-dark border border-slate-200 dark:border-slate-700 rounded-xl shadow-2xl overflow-hidden">
              <div className="flex items-center gap-2 px-4 py-3 border-b border-slate-200 dark:border-slate-700 bg-slate-50 dark:bg-slate-800/50">
                <div className="flex gap-1.5">
                  <div className="w-3 h-3 rounded-full bg-red-400"></div>
                  <div className="w-3 h-3 rounded-full bg-yellow-400"></div>
                  <div className="w-3 h-3 rounded-full bg-green-400"></div>
                </div>
                <div className="mx-auto text-xs text-slate-400 font-mono">uniscout.ai/report/fintech-disrupt-v2</div>
              </div>
              <div className="p-8 grid grid-cols-1 md:grid-cols-3 gap-8">
                <div className="col-span-1 space-y-4">
                  <div className="h-32 bg-slate-100 dark:bg-slate-800 rounded-lg animate-pulse"></div>
                  <div className="h-4 w-3/4 bg-slate-100 dark:bg-slate-800 rounded animate-pulse"></div>
                  <div className="h-4 w-1/2 bg-slate-100 dark:bg-slate-800 rounded animate-pulse"></div>
                  <div className="space-y-2 mt-8">
                    <div className="h-8 bg-indigo-50 dark:bg-indigo-900/20 border-l-4 border-indigo-500 px-3 flex items-center text-sm font-medium text-indigo-700 dark:text-indigo-300">Executive Summary</div>
                    <div className="h-8 px-3 flex items-center text-sm text-slate-500 dark:text-slate-400">Market Sizing</div>
                    <div className="h-8 px-3 flex items-center text-sm text-slate-500 dark:text-slate-400">Competitive Landscape</div>
                    <div className="h-8 px-3 flex items-center text-sm text-slate-500 dark:text-slate-400">Team Analysis</div>
                  </div>
                </div>
                <div className="col-span-1 md:col-span-2 space-y-6">
                  <div className="flex justify-between items-start">
                    <div>
                      <h3 className="text-2xl font-bold text-slate-800 dark:text-white">FinTech Disrupt Inc.</h3>
                      <span className="text-sm text-slate-500">Seed Stage • B2B SaaS • San Francisco</span>
                    </div>
                    <span className="bg-green-100 text-green-700 dark:bg-green-900/30 dark:text-green-400 px-3 py-1 rounded-full text-sm font-bold">Score: 8.5/10</span>
                  </div>
                  <div className="bg-slate-50 dark:bg-slate-800/50 p-4 rounded-lg border border-slate-100 dark:border-slate-700">
                    <h4 className="font-semibold mb-2 text-slate-700 dark:text-slate-200">AI Summary</h4>
                    <div className="space-y-2">
                      <div className="h-2 w-full bg-slate-200 dark:bg-slate-700 rounded"></div>
                      <div className="h-2 w-full bg-slate-200 dark:bg-slate-700 rounded"></div>
                      <div className="h-2 w-2/3 bg-slate-200 dark:bg-slate-700 rounded"></div>
                    </div>
                  </div>
                  <div className="grid grid-cols-2 gap-4">
                    <div className="p-4 rounded-lg bg-white dark:bg-slate-800 shadow-sm border border-slate-100 dark:border-slate-700">
                      <div className="text-sm text-slate-500 mb-1">Market Opportunity</div>
                      <div className="text-xl font-bold text-slate-900 dark:text-white">$45B TAM</div>
                      <div className="text-xs text-green-500 mt-1 flex items-center">
                        <span className="material-icons text-[14px]">trending_up</span> High Growth
                      </div>
                    </div>
                    <div className="p-4 rounded-lg bg-white dark:bg-slate-800 shadow-sm border border-slate-100 dark:border-slate-700">
                      <div className="text-sm text-slate-500 mb-1">Risk Level</div>
                      <div className="text-xl font-bold text-slate-900 dark:text-white">Moderate</div>
                      <div className="text-xs text-yellow-500 mt-1 flex items-center">
                        <span className="material-icons text-[14px]">warning</span> Regulatory
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="py-10 border-y border-slate-100 dark:border-slate-800 bg-white dark:bg-surface-dark">
        <div className="max-w-7xl mx-auto px-4 text-center">
          <p className="text-sm font-semibold text-slate-400 uppercase tracking-wider mb-6">Trusted by leading VCs and Angel Investors</p>
          <div className="flex flex-wrap justify-center items-center gap-8 md:gap-16 opacity-50 grayscale hover:grayscale-0 transition-all duration-500">
            <div className="text-xl font-bold font-display text-slate-800 dark:text-white">VENTURE<span className="text-primary">ONE</span></div>
            <div className="text-xl font-bold font-display text-slate-800 dark:text-white flex items-center gap-1"><span className="material-icons">bolt</span>Catalyst</div>
            <div className="text-xl font-bold font-display text-slate-800 dark:text-white">Seed<span className="font-light">Fund</span></div>
            <div className="text-xl font-bold font-display text-slate-800 dark:text-white flex items-center gap-1"><span className="material-icons">diamond</span>Apex</div>
            <div className="text-xl font-bold font-display text-slate-800 dark:text-white">HORIZON</div>
          </div>
        </div>
      </section>

      <section className="py-24 bg-background-light dark:bg-background-dark relative" id="features">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center max-w-3xl mx-auto mb-16">
            <h2 className="text-base font-semibold text-primary tracking-wide uppercase">Features</h2>
            <p className="mt-2 text-3xl leading-8 font-extrabold tracking-tight text-slate-900 dark:text-white sm:text-4xl">
              Smarter Decisions, Faster.
            </p>
            <p className="mt-4 max-w-2xl text-xl text-slate-500 dark:text-slate-400 mx-auto">
              Stop spending hours reading decks. Let uniscout analyze the data, verify the claims, and flag the risks.
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="bg-surface-light dark:bg-surface-dark p-8 rounded-2xl shadow-sm hover:shadow-xl transition-shadow border border-slate-100 dark:border-slate-800 group">
              <div className="w-14 h-14 rounded-xl bg-blue-100 dark:bg-blue-900/30 flex items-center justify-center mb-6 group-hover:scale-110 transition-transform">
                <span className="material-icons text-blue-600 dark:text-blue-400 text-3xl">analytics</span>
              </div>
              <h3 className="text-xl font-bold text-slate-900 dark:text-white mb-3">Instant Deep Dives</h3>
              <p className="text-slate-600 dark:text-slate-400 leading-relaxed">
                Upload any URL or PDF. Our AI extracts key metrics, value propositions, and team backgrounds instantly to generate a comprehensive memo.
              </p>
            </div>
            <div className="bg-surface-light dark:bg-surface-dark p-8 rounded-2xl shadow-sm hover:shadow-xl transition-shadow border border-slate-100 dark:border-slate-800 group">
              <div className="w-14 h-14 rounded-xl bg-purple-100 dark:bg-purple-900/30 flex items-center justify-center mb-6 group-hover:scale-110 transition-transform">
                <span className="material-icons text-purple-600 dark:text-purple-400 text-3xl">travel_explore</span>
              </div>
              <h3 className="text-xl font-bold text-slate-900 dark:text-white mb-3">Market Verification</h3>
              <p className="text-slate-600 dark:text-slate-400 leading-relaxed">
                We don't just read the deck. uniscout cross-references claims against live market data, competitor websites, and industry reports.
              </p>
            </div>
            <div className="bg-surface-light dark:bg-surface-dark p-8 rounded-2xl shadow-sm hover:shadow-xl transition-shadow border border-slate-100 dark:border-slate-800 group">
              <div className="w-14 h-14 rounded-xl bg-pink-100 dark:bg-pink-900/30 flex items-center justify-center mb-6 group-hover:scale-110 transition-transform">
                <span className="material-icons text-pink-600 dark:text-pink-400 text-3xl">radar</span>
              </div>
              <h3 className="text-xl font-bold text-slate-900 dark:text-white mb-3">Red Flag Radar</h3>
              <p className="text-slate-600 dark:text-slate-400 leading-relaxed">
                Spot inconsistencies in financial projections, cap table issues, or competitive threats that might be hidden in the fine print.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="py-24 bg-surface-light dark:bg-surface-dark" id="how-it-works">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
            <div>
              <h2 className="text-3xl font-extrabold text-slate-900 dark:text-white sm:text-4xl mb-6">
                From Pitch Deck to Investment Memo in Minutes
              </h2>
              <p className="text-lg text-slate-600 dark:text-slate-400 mb-8">
                Streamline your deal flow pipeline with a process designed for modern investors.
              </p>
              <div className="space-y-8">
                <div className="flex">
                  <div className="flex-shrink-0">
                    <div className="flex items-center justify-center h-10 w-10 rounded-full bg-primary text-white font-bold">1</div>
                  </div>
                  <div className="ml-4">
                    <h4 className="text-lg font-bold text-slate-900 dark:text-white">Upload Materials</h4>
                    <p className="mt-2 text-slate-600 dark:text-slate-400">Drag and drop pitch decks, link a Notion page, or paste a website URL.</p>
                  </div>
                </div>
                <div className="flex">
                  <div className="flex-shrink-0">
                    <div className="flex items-center justify-center h-10 w-10 rounded-full bg-secondary text-white font-bold">2</div>
                  </div>
                  <div className="ml-4">
                    <h4 className="text-lg font-bold text-slate-900 dark:text-white">AI Analysis</h4>
                    <p className="mt-2 text-slate-600 dark:text-slate-400">Our engines process the data, perform web searches for validation, and structure the findings.</p>
                  </div>
                </div>
                <div className="flex">
                  <div className="flex-shrink-0">
                    <div className="flex items-center justify-center h-10 w-10 rounded-full bg-accent text-white font-bold">3</div>
                  </div>
                  <div className="ml-4">
                    <h4 className="text-lg font-bold text-slate-900 dark:text-white">Review & Export</h4>
                    <p className="mt-2 text-slate-600 dark:text-slate-400">Get a scored report, customizable memo, and actionable questions for the founder call.</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="relative">
              <div className="absolute inset-0 bg-logo-gradient rounded-3xl blur-2xl opacity-20 transform rotate-3"></div>
              <div className="relative bg-slate-900 rounded-2xl shadow-2xl p-6 border border-slate-700">
                <div className="font-mono text-sm text-slate-300 space-y-2">
                  <div className="flex items-center gap-2 text-green-400">
                    <span className="material-icons text-sm">check_circle</span>
                    <span>Reading pitch_deck_v3.pdf...</span>
                  </div>
                  <div className="flex items-center gap-2 text-green-400">
                    <span className="material-icons text-sm">check_circle</span>
                    <span>Extracting financial tables...</span>
                  </div>
                  <div className="flex items-center gap-2 text-blue-400 animate-pulse">
                    <span className="material-icons text-sm">search</span>
                    <span>Searching competitors (Crunchbase, LinkedIn)...</span>
                  </div>
                  <div className="pl-6 text-slate-500 border-l border-slate-700 my-2">
                    &gt; Found 3 direct competitors<br />
                    &gt; Verifying TAM calculation...
                  </div>
                  <div className="flex items-center gap-2 text-purple-400 mt-4">
                    <span className="material-icons text-sm">auto_awesome</span>
                    <span>Generating risk assessment matrix...</span>
                  </div>
                  <div className="mt-6 p-4 bg-slate-800 rounded border border-slate-600">
                    <div className="text-xs text-slate-400 mb-1">OUTPUT PREVIEW</div>
                    <div className="text-white font-bold">Recommendation: PROCEED WITH CAUTION</div>
                    <div className="text-slate-400 text-xs mt-1">Strong team, but CAC is 2x industry average.</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="py-20 relative overflow-hidden">
        <div className="absolute inset-0 bg-slate-900"></div>
        <div className="absolute inset-0 bg-logo-gradient opacity-10"></div>
        <div className="relative max-w-4xl mx-auto px-4 text-center z-10">
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-6">Start Scouting Smarter Today</h2>
          <p className="text-xl text-indigo-200 mb-10">Join 500+ investors using uniscout to uncover the next unicorn.</p>
          <form className="max-w-lg mx-auto flex flex-col sm:flex-row gap-3">
            <input className="flex-1 px-5 py-4 rounded-xl border-0 focus:ring-2 focus:ring-accent text-slate-900 placeholder-slate-400" placeholder="Enter your work email" type="email" />
            <button className="bg-logo-gradient hover:opacity-90 text-white font-bold py-4 px-8 rounded-xl transition-all shadow-lg transform hover:-translate-y-1" type="button">
              Get Early Access
            </button>
          </form>
        </div>
      </section>

      <footer className="bg-background-light dark:bg-background-dark border-t border-slate-200 dark:border-slate-800 pt-12 pb-8">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
            <div className="col-span-1 md:col-span-1">
              <img alt="uniscout Logo" className="h-10 mb-4" src="/logo.png" />
              <p className="text-sm text-slate-500 dark:text-slate-400">
                Empowering investors with AI-driven insights for faster, smarter deal flow.
              </p>
            </div>
            <div>
              <h4 className="font-bold text-slate-900 dark:text-white mb-4">Product</h4>
              <ul className="space-y-2 text-sm text-slate-600 dark:text-slate-400">
                <li><a className="hover:text-primary" href="#">Features</a></li>
                <li><a className="hover:text-primary" href="#">Pricing</a></li>
              </ul>
            </div>
            <div>
              <h4 className="font-bold text-slate-900 dark:text-white mb-4">Legal</h4>
              <ul className="space-y-2 text-sm text-slate-600 dark:text-slate-400">
                <li><Link className="hover:text-primary" to="/privacy-policy">Privacy Policy</Link></li>
                <li><Link className="hover:text-primary" to="/terms-of-service">Terms of Service</Link></li>
              </ul>
            </div>
          </div>
          <div className="border-t border-slate-200 dark:border-slate-800 pt-8 flex flex-col md:flex-row justify-between items-center">
            <div className="flex space-x-4 mt-4 md:mt-0">
              <a className="text-slate-400 hover:text-slate-500 dark:hover:text-slate-300" href="#">
                <span className="sr-only">Twitter</span>
                <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24"><path d="M8.29 20.251c7.547 0 11.675-6.253 11.675-11.675 0-.178 0-.355-.012-.53A8.348 8.348 0 0022 5.92a8.19 8.19 0 01-2.357.646 4.118 4.118 0 001.804-2.27 8.224 8.224 0 01-2.605.996 4.107 4.107 0 00-6.993 3.743 11.65 11.65 0 01-8.457-4.287 4.106 4.106 0 001.27 5.477A4.072 4.072 0 012.8 9.713v.052a4.105 4.105 0 003.292 4.022 4.095 4.095 0 01-1.853.07 4.108 4.108 0 003.834 2.85A8.233 8.233 0 012 18.407a11.616 11.616 0 006.29 1.84"></path></svg>
              </a>
              <a className="text-slate-400 hover:text-slate-500 dark:hover:text-slate-300" href="#">
                <span className="sr-only">LinkedIn</span>
                <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24"><path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z"></path></svg>
              </a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}
